import React, { useMemo, useState, useRef } from 'react';
import Comment from '../Comment';
import FloatingHeart from '../floatingEmos/FloatingHeart';
import useWindowDimensions from '../../theme/useWindowDimensions';
import Container from '@material-ui/core/Container';
import IconButton from '@material-ui/core/IconButton';
import SendSharpIcon from '@material-ui/icons/SendSharp';
import Typography from '@material-ui/core/Typography';
import FavoriteSharpIcon from '@material-ui/icons/FavoriteSharp';
import ThumbUpSharpIcon from '@material-ui/icons/ThumbUpSharp';
import makeStyles from '@material-ui/core/styles/makeStyles';
import messageBoxStyles from '../../styles/messageBoxStyles';

import EmojiEmotionsIcon from '@material-ui/icons/EmojiEmotions';
import 'emoji-mart/css/emoji-mart.css';
import data from 'emoji-mart/data/twitter.json';
import { NimblePicker } from 'emoji-mart';
// import CustomPopover from '../customPopover';

const useStyles = makeStyles((theme) => messageBoxStyles(theme));

function MessageBox({
  commentData,
  text,
  setText,
  onClickSend,
  onClickEmoSend,
  isServiceActive,
  showEmo,
  userId,
  chatRange,
  clearMsgNotification,
  participantName,
}) {
  const classes = useStyles();
  const { height } = useWindowDimensions();
  const [emojisVis, setEmojisVis] = useState(false);
  const elRefRen = useRef(null);
  const inputRef = useRef(null);

  const handleClose = () => {
    setEmojisVis(false);
    inputRef.current.focus();
  };

  const handleChange = (e) => {
    try {
      setText(e.target.value);
    } catch (error) {
      console.log(error, 'error updating text');
    }
  };

  const sendMsg = async () => {
    try {
      if (text && text?.replace(/\s/g, '')) {
        onClickSend(text);
        handleClose();
        setText('');
        return;
      }
    } catch (error) {
      console.log("couldn't send the message", error);
    }
  };

  const handleEnter = (e) => {
    if (e.key === 'Enter') {
      sendMsg();
      return;
    }
  };

  const sendEmo = (emoCode) => {
    try {
      onClickEmoSend(emoCode);
      return;
    } catch (error) {
      console.log("couldn't send emo", error);
    }
  };

  const toggleEmojiList = () => {
    setEmojisVis((prevState) => !prevState);
  };

  const handleEmojiSelect = (e) => {
    setText((prevState) => prevState + e.native);
    inputRef.current.focus();
    // inputRef.current.scrollIntoView();
  };

  const heartComp = useMemo(() => {
    if (!showEmo?.emoCode) {
      return null;
    } else if (showEmo?.emoCode === '%heart%') {
      return (
        <FloatingHeart
          animatedEmoji={showEmo}
          objThing={
            <FavoriteSharpIcon style={{ fill: '#FC46AA', zIndex: 50000000 }} />
          }
        />
      );
    } else {
      return <FloatingHeart animatedEmoji={showEmo} objThing={null} />;
    }
  }, [showEmo]);

  const likeComp = useMemo(() => {
    if (!showEmo?.emoCode) {
      return null;
    } else if (showEmo?.emoCode === '%like%') {
      return (
        <FloatingHeart
          animatedEmoji={showEmo}
          objThing={
            <ThumbUpSharpIcon style={{ fill: '#5DADE2', zIndex: 50000000 }} />
          }
        />
      );
    } else {
      return <FloatingHeart animatedEmoji={showEmo} objThing={null} />;
    }
  }, [showEmo]);

  return (
    <Container className={classes.container}>
      <div
        className={classes.inputContainer}
        style={{
          height: height * 0.06,
        }}
      >
        <input
          type="text"
          ref={inputRef}
          placeholder={chatRange + '   type here..'}
          value={text}
          onChange={handleChange}
          onKeyPress={handleEnter}
          className={classes.inputElement}
        />

        <IconButton onClick={toggleEmojiList}>
          <EmojiEmotionsIcon className={classes.emojiIcon} />
        </IconButton>
        <div ref={elRefRen} />
        {emojisVis && (
          <div
            className={classes.emojiContainer}
            style={{ transform: `translate(0px,-${height * 0.06}px)` }}
          >
            <NimblePicker
              set="twitter"
              data={data}
              showPreview={false}
              showSkinTones={false}
              onSelect={handleEmojiSelect}
            />
          </div>
        )}
        <IconButton onClick={sendMsg}>
          <SendSharpIcon className={classes.emojiIcon} />
        </IconButton>
        {heartComp}
        <IconButton onClick={() => sendEmo('%heart%')}>
          <FavoriteSharpIcon className={classes.favouriteIcon} />
        </IconButton>
        {likeComp}
        <IconButton onClick={() => sendEmo('%like%')}>
          <ThumbUpSharpIcon className={classes.likeIcon} />
        </IconButton>
      </div>
      {isServiceActive ? (
        <Comment
          data={commentData}
          identity={userId}
          clearMsgNotification={clearMsgNotification}
          participantName={participantName}
        />
      ) : (
        <>
          <Typography variant="subtitle2">
            If you see this message for extended period of time, please check
            your internet connection and reconnect
          </Typography>
          <Typography variant="subtitle2">Loading chat..</Typography>
        </>
      )}
    </Container>
  );
}

export default MessageBox;
